import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "90px",
			height: "90px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			borderRadius: "10px",
			marginRight: "25px",
			flexShrink: "0",
		},
		mark: {
			fontFamily: "MuseoSansCyrl-500",
			fontSize: "30px",
			lineHeight: "0.6",
			color: theme.palette.colors.white,
			marginBottom: "7px",
		},
		text: {
			fontFamily: "MuseoSansCyrl-500",
			fontSize: "14px",
			lineHeight: "1",
			textAlign: "center",
			color: theme.palette.colors.white,
		},
		yellowTheme: {
			"& $mark": {
				color: theme.palette.colors.yellow,
			},
		},
		whiteTheme: {
			border: `solid 1px ${theme.palette.colors.disabled}`,
			"& $mark": {
				color: theme.palette.colors.darkSlateBlue,
			},
			"& $text": {
				color: theme.palette.colors.darkSlateBlue,
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				flexDirection: "row",
				justifyContent: "flex-start",
				width: "auto",
				height: "40px",
				padding: "0 23px 0 13px",
			},
			mark: {
				fontSize: "24px",
				marginRight: "10px",
				lineHeight: 1,
				marginBottom: 0,
			},
			yellowTheme: {
				marginBottom: "10px",
				marginRight: 0,
				"&:last-child": {
					paddingBottom: 0,
				},
			},
		},
	};
};

const RatingSquare = ({ classes, color, yellowTheme, whiteTheme, mark, text }) => {
	let styles = {
		backgroundColor: color,
	};

	return (
		<div
			className={classNames(classes.root, {
				[classes.yellowTheme]: yellowTheme,
				[classes.whiteTheme]: whiteTheme,
			})}
			style={styles}
		>
			<div className={classes.mark}>{mark}</div>
			<div className={classes.text}>{text}</div>
		</div>
	);
};

RatingSquare.defaultProps = {
	color: "rgba(44, 29, 93, 0.1)",
	mark: 0,
	yellowTheme: false,
	whiteTheme: false,
};

export default withStyles(styles)(RatingSquare);

export { RatingSquare as __RatingSquare };
